import { Helmet } from "react-helmet";
import AnimalGrid from "components/animalgrid";
import BodyText from "components/bodytext";
import ContentBox from "components/contentbox";
import HeaderText from "components/headertext";
import PageGallery from "components/pagegallery";
import collectionMeta from "content/collections/plains-hognose-snake.json";
import { animalGridFromJson } from "hooks/useGallery";

const animalGridData = animalGridFromJson(collectionMeta);

const PlainsHognoseSnake = () => {
  return (
    <ContentBox>
      <Helmet>
        <title>{collectionMeta.commonName}</title>
        <meta
          name="description"
          content="See the Plains Hognose Snakes (Heterodon nasicus)
            that are being kept here and learn more about their captive husbandry."
        />
        <link rel="canonical" href="https://www.gcreptiles.com/plains-hognose-snake" />
      </Helmet>
      <HeaderText
        title={collectionMeta.commonName}
        subtitle={collectionMeta.scientificName}
      />
      <AnimalGrid data={animalGridData} />
      <BodyText>
        I've always been interested in Hognose snakes but it took my son to
        convince me that we needed to get one. The upturned snout that they have
        is ideal for burrowing in dirt and ever since we began owning one I've
        seen it get lots of use. There are several inches of substrate in this
        one's cage which is a mix of orchid bark, coco fiber, and coco chip. Our
        Hognose spends most of his time down in the tunnels that he has dug and
        maybe 2 or 3 times a week he'll surface to see if one of us food-monkeys
        is feeding him that day. I have plenty of pictures of him with dirt on
        top of his head when he surfaces for a visit. Total derp.
      </BodyText>
      <PageGallery slug="plains-hognose-snake" maxWidth="900" />
    </ContentBox>
  );
};

export default PlainsHognoseSnake;
